import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css'; // Importação correta do global.css
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/E-commerce-semijoias">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);